import { useAuth0 } from "@auth0/auth0-react";
import Grid from '@mui/material/Grid';
import FinanceService from "Lib/API/Finance";
import FinanceSettingService from "Lib/API/FinanceSetting/FinanceSetting";
import MembersSettingService from "Lib/API/MemberSetting/MemeberSetting";
import dateIcon from "assets/icons/date-picker.svg";
import BottomArrowSvg from "assets/icons/svg/BottomArrowSvg";
import { InputField, LabelField, SelectField } from "components";
import { CheckBox } from "components/CheckBox/CheckBox";
import InfoTooltip from "components/InfoTooltip";
import { MenuMultiCheckBox } from "components/MenuMultiCheckBox/MenuMultiCheckBox";
import { MultiSelect } from 'components/MultiSelect/MultiSelect';
import { AsyncAutoCompleteField } from "components/autoCompleteField/AsyncAutoFieldOld";
import { getDateFormat, getDateFormatForDatePicket, maskDate } from "helper/dateFormat.js";
import { useSearch } from "hook";
import moment from "moment";
import React, { useEffect, useState } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { toastr } from "react-redux-toastr";
import Select, { components } from "react-select";
import MaskedInput from "react-text-mask";
import { DateRangePicker } from "rsuite";
import "rsuite/dist/rsuite.min.css";
import createAutoCorrectedDatePipe from "text-mask-addons/dist/createAutoCorrectedDatePipe";
import { DateFormetContext } from "../../../app/App.js";
import * as filterVariables from "./ReportFiltersVariables";
import "./index.scss";

const selectControlStyles = {
  backgroundColor: "#FFFFFF",
  color: "#b5b5c3",
  transition:
    "color 0.15s ease, background-color 0.15s ease, border-color 0.15s ease, box-shadow 0.15s ease",
  paddingTop: "6px",
  paddingBottom: "6px",
  cursor: "pointer",
};
const colourStyles = {
  control: (styles) => ({
    ...styles,
    ...selectControlStyles,
  }),
};

const batchTypeOptions = [
  {
    label: "unsynced",
    value: "unsynced",
  },
  {
    label: "synced",
    value: "synced",
  },
];


export const Filter = ({
  filters,
  onSearchChange,
  onChargeDateChange,
  onPaidDateChange,
  onAmountChange,
  onChargedStatusChange,
  onPaymentStatusChange,
  onOverdueDaysChange,
  onClear,
  onStatusChange,
  setTabClick,
  setFilters,
  initialFilters,
  toggle,
  setOpenReport,
  type,
  reportName,
  reportIndex,
  formik,
}) => {

  const [loading, setLoading] = React.useState(false);
  const [data, setData] = useState();
  const [dateRange, setDateRange] = useState([null, null]);
  const [date, setDate] = useState("");
  const [date1, setDate1] = useState([]);
  const [startDate, endDate] = dateRange;
  const [calendar, setCalender] = useState(false);
  const [rangeCalendar, setRangeCalender] = useState(false);
  const [search, setSearch] = useState("");
  const [selectedAccount, setSelectedAccount] = useState([]);
  const [ledgers, setLedgers] = useState([]);
  const { searchAction } = useSearch({ action: setSearch });
  const { getAccessTokenSilently } = useAuth0();
  const autoCorrectedDatePipe = createAutoCorrectedDatePipe(getDateFormatForDatePicket() || 'mm/dd/yyyy');
  const [catagoryTypes, setCatagoryTypes] = useState([])
  const [accountBillingTypes, setAccountBillingTypes] = useState([]);
  const [catagoryLoading, setCatagoryLoading] = useState(false);
  const [accountBillingLoading, setAccountBillingLoading] = useState(false);
  const [catagoryTotal, setCatagoryTotal] = useState(null);
  const [billingTotal, setBillingTotal] = useState(null);
  const [paymentTypes, setPaymentTypes] = useState([]);
  const [paymentTypeLoading, setPaymentTypeLoading] = useState(false);
  const [paymentMethodTotal, setPaymentMethodTotal] = useState(null);

  const dateTimeMask = maskDate();
  const dateFormatPlaceholder = getDateFormat();
  const dateFormat = getDateFormatForDatePicket();


   const reportsDataFilters =[
    {reportName:"Payment by payment method type",
      filterTypes:[{type:"Range", isOptinal:false},{type:"Ledger Account", isOptinal:true},
      {type:"Payment method", isOptinal:true,data: paymentTypes, loading: paymentTypeLoading, formikField: `account[paymentMethod]`, 
      variableForSave: 'title', formikKey: 'paymentMethod', total: paymentMethodTotal},
      {type:"CheckBox",formikField: `account`,key:"detailedByPaymentMethod",label:'Detailed by payment' }
    ]},


    {reportName:"Billing Report by Account (Family)",
  filterTypes:[{type:"Range", isOptinal:false},{type:"Ledger Account", isOptinal:true},
  {type:"Member Type", isOptinal:true,data: filterVariables.AccountTypes,formikField: `account[account_type]`, variableForSave: 'value', formikKey: 'account_type',total: 3},
  {type:"Billing type", isOptinal:true,data: accountBillingTypes, loading: accountBillingLoading,formikField: `account[billing_type]`, variableForSave: 'title', formikKey: 'billing_type',total: billingTotal},
  {type:"Category Type", isOptinal:true,data: catagoryTypes, loading: catagoryLoading, formikField: `account[category]`, 
  variableForSave: 'title', formikKey: 'category', total: catagoryTotal},
  {type:"CheckBox",formikField: `account`,key:"detailedByFamily",label:'Detailed by account' },
  {type:"empty"},
  {type:"CheckBox",formikField: `account`,key:"includeAccountInformation",label:'Include account information in CSV/Excel export' }

]},
{reportName:"Billing Report by Ledger",
  filterTypes:[{type:"Range", isOptinal:false},{type:"Ledger Account", isOptinal:true},
  {type:"Member Type", isOptinal:true,data: filterVariables.AccountTypes,formikField: `account[account_type]`, variableForSave: 'value', formikKey: 'account_type',total: 3},
  {type:"Billing type", isOptinal:true,data: accountBillingTypes, loading: accountBillingLoading,formikField: `account[billing_type]`, variableForSave: 'title', formikKey: 'billing_type',total: billingTotal},
  {type:"Category Type", isOptinal:true,data: catagoryTypes, loading: catagoryLoading, formikField: `account[category]`, 
  variableForSave: 'title', formikKey: 'category', total: catagoryTotal},
  {type:"CheckBox",formikField: `account`,key:"detailedByFamily",label:'Detailed by account' },
  {type:"empty"},
  ...(formik?.values?.account?.detailedByFamily ? [{type:"CheckBox",formikField: `account`,key:"includeAccountInformation",label:'Include account information in CSV/Excel export' }] : []),

]}

  ,{reportName:"Credit on Account",filterTypes:[{type:"Account IDs", isOptinal:true}]},
  {reportName:"Aged account receivable summarized by Ledger",filterTypes:[{type:"Date", isOptinal:false},{type:"Account", isOptinal:true}]},
  {reportName:"Aged account receivable summarized by Family",filterTypes:[
    {type:"Date", isOptinal:false},{type:"Account", isOptinal:true},{type:"Ledger Account", isOptinal:true},
    {type:"CheckBox",formikField: `account`,key:"includeAccountInformation",label:'Include account information in CSV/Excel export' }
  
  ]}
  ,{reportName:"Billing Summarized by Ledger",filterTypes:[{type:"Range", isOptinal:false},{type:"Account", isOptinal:true},{type:"Ledger Account", isOptinal:true}]},
  {reportName:"Batch details",filterTypes:[{type:"Range", isOptinal:false},{type:"Batch ID", isOptinal:true},{type:"Batch Type", isOptinal:true}]}
  ,{reportName:"Ledger report",filterTypes:[{type:"Range", isOptinal:false},{type:"Batch ID", isOptinal:true},{type:"Batch Type", isOptinal:true}]},
  {reportName:"Ledger account summary",filterTypes:[{type:"Date", isOptinal:false},{type:"Range", isOptinal:false},{type:"Batch ID", isOptinal:true},{type:"Batch Type", isOptinal:true}]}]
  
 
  //Account Category
  const getAccountCategory = async () => {
    const token = await getAccessTokenSilently();
    setCatagoryLoading(true)
    await MembersSettingService.getCatagoryListByType(null, token, search?.value)
        .then((res) => {
          const formattedCatagoryTypes = res?.result?.map((item) => {
            return {
              ...item,
              id: item._id,
            }
          })
            setCatagoryTypes(formattedCatagoryTypes);
            setCatagoryLoading(false)
            setCatagoryTotal(res?.count)
        }).catch((err) => {
            toastr.error("Error", err?.data?.message);
            setCatagoryTypes([]);
            setCatagoryLoading(false)
        });
  }
  //Billing Type
  const getBillingType = async (type) => {
    const token = await getAccessTokenSilently();
    setAccountBillingLoading(true)
    // Account Billing Api
    await FinanceSettingService.getAccountBillingTypes(token).then((res) => {
      const formattedAccountBillingTypes = res?.result?.map((item) => {
        return {
          ...item,
          id: item._id,
        }
      })
        setAccountBillingTypes(formattedAccountBillingTypes);
        setBillingTotal(res?.count)
        setAccountBillingLoading(false)
    }).catch((err) => {
        toastr.error("Error", err?.data?.message);
        setAccountBillingTypes([]);
        setAccountBillingLoading(false)
    });

}

  // Payment method
  const getPaymentMethod = async () => {
    const token = await getAccessTokenSilently();
    setPaymentTypeLoading(true)
    await FinanceSettingService.getAllPaymentTypes(token, true)
      .then((res) => {
        const formattedPaymentMethod = res?.result?.map((item) => {
          return {
            ...item,
            title: item.type,
            id: item._id,
          }
        })
        setPaymentTypes(formattedPaymentMethod)
        setPaymentMethodTotal(res?.count)
      })
      .catch((e) => {
        toastr.error(e?.data?.message ?? "Error");
      }).finally(() => {
        setPaymentTypeLoading(false)
      });
  }

  const enableLoading = (value) => {
    setLoading(value);
  };
  const DropdownIndicator = (props) => {
    return (
      <components.DropdownIndicator {...props}>
        <BottomArrowSvg label="Emoji" />
      </components.DropdownIndicator>
    );
  };
  const formatOptionLabel = ({ label, account_id }) => {
    return (
      <div className="dropdown-container" key={account_id}>
        <div className="icon-name-container d-flex align-items-center justify-content-start">
          <div className="name-container" style={{ marginInlineStart: 10 }}>
            <div>{label}</div>
          </div>
        </div>
      </div>
    );
  };
  const handleAccountChange = (value) => {
    if(!value) {
      setSelectedAccount([]);
      const { account, ...rest } = filters.filter;
      setFilters((prev) => ({
        ...prev,
        filter: {
          ...rest,
        },
      }));
      return;
    }
    setFilters((prev) => ({
      ...prev,
      filter: {
        ...prev.filter,
        account: value._id
      },
    }));
    setSelectedAccount({
      id: value._id,
      accountId: value.account_id,
      name: value.label,
    });
  };
  const dateRangeChange = (update) => {
    let start = update[0] ? moment(update[0]).format("MM/DD/YYYY") : null;
    let end = update[1] ? moment(update[1]).format("MM/DD/YYYY") : null;
    setDateRange(update);
    if (start && end) {
      setFilters((prev) => ({
        ...prev,
        filter: {
          ...prev.filter,
          dateRange: {
            start: start,
            end: end,
          },
        },
      }));
    } else {
      const { dateRange, ...rest } = filters.filter;
      setFilters((prev) => ({
        ...prev,
        filter: {
          ...rest,
        },
      }));
    }
  };

  const onSubLedgerChange = (e) => {
    setFilters((prev) => ({
      ...prev,
      filter: {
        ...prev.filter,
        subLedger: e,
      },
    }));
  };
  const onLedgerAccountChange = (e) => {
    setFilters((prev) => ({
      ...prev,
      filter: {
        ...prev.filter,
        ledger: e,
      },
    }));
  };

  const handleFormikChange = (items, formikField, variableForSave) => {
    formik.setFieldValue(formikField, items);
  }
  useEffect(() => {
    onLedgerAccountChange(formik.values?.ledger);
    onSubLedgerChange(formik.values?.subLedger);
  }, [formik?.values]);

  useEffect(() => {
    async function fetchMyAPI() {
      enableLoading(true);
      const token = await getAccessTokenSilently();
      await FinanceService.getACcountNames(token, search)
        .then((res) => {
          if (res?.accounts) {
            res.accounts.map((item) => {
              item.id = item.account_id;
              item.label = item.family_name;
              item.value = item.account_id;
              return item;
            });
            setData(res?.accounts);
          }
          enableLoading(false);
        })
        .catch((err) => {
          toastr.error("Error", err?.data?.message);
        });
    }

    if (search?.length > 2) {
      fetchMyAPI();
    } else {
      setData([]);
    }
  }, [search]);

  useEffect(() => {
    if (endDate < startDate) {
      toastr.error("End Date should be greater than start date.");
      dateRangeChange([null, null]);
      setDate1([]);
    }
  }, [endDate]);

  useEffect(() => {
    setRangeCalender(false);
  }, [endDate]);

  useEffect(() => {
    async function getLedgeraccounts() {
      const token = await getAccessTokenSilently();
      const res = await FinanceService.getLedgerSubLedgerList(token);
      if (res?.ledgers) {
        const arrayWithSelectAll = ["Select All", ...res?.ledgers];
        setLedgers(arrayWithSelectAll);
      }
    }
    getLedgeraccounts();
  }, [getAccessTokenSilently]);

  useEffect(() => {
    if (date) {
      setFilters((prev) => ({
        ...prev,
        filter: {
          ...prev.filter,
          date: moment(date).format("MM/DD/YYYY"),
        },
      }));
    } else {
      const updatedFilter = { ...filters.filter };
      delete updatedFilter.date;
     setFilters((prev) => ({
        ...prev,
        filter: {
          ...updatedFilter,
        },
      }));
    }
  }, [date]);

  useEffect(()=>{
  if(reportName === "Billing Report by Account (Family)" || reportName === "Billing Report by Ledger"){
    getAccountCategory()
    getBillingType()
  }
  if(reportName === "Payment by payment method type"){
    getPaymentMethod()
  }
  },[reportName])




  return (
    <div className="reports-filteration">
      <div className="activated-ledger  mb-5 mx-5 pl-20" >
      <Grid container rowSpacing={1} columnSpacing={{ xs: 1, sm: 2, md: 3 }}>
        {reportsDataFilters?.map((val)=>{
        return (
          val?.filterTypes?.map((item)=>{
            if(val?.reportName === reportName){
            switch (item?.type) {
              case 'Date':
                return (  
                  <Grid item xs={6}>
                <div className="fieldContainer">
                <div className="date-wrapper docu-date">
                  <LabelField
                    title={"Date"}
                    mandatory={!item?.isOptinal} 
                  />
                  <DatePicker
                    isClearable
                    showIcon
                    placeholderText={dateFormatPlaceholder}
                    dateFormat={dateFormat}
                    selected={date && new Date(date)}
                    onChange={(e) => {
                      setCalender(false);
                      setDate(e);
                    }}
                    customInput={
                      <MaskedInput
                        pipe={autoCorrectedDatePipe}
                        mask={dateTimeMask}
                        keepCharPositions={true}
                        guide={true}
                      />
                    }
                  />
                </div>
              </div>
              </Grid>
            )
              case "Range" :
                return(   
                  <Grid item xs={6}>
                <div className="fieldContainer">
              <div className="date-wrapper docu-date">
                <div className="d-flex align-items-center">
                  <LabelField
                    title={"Range"}
                    mandatory={!item?.isOptinal}
                  />
                  <InfoTooltip text="Limits the report to transactions or activity that fall within this date range." style={{ marginLeft: '6px', transform: 'translateY(-4px)' }} />
                </div>
                <div className="datepicker-container">
                  <DateRangePicker
                    format={dateFormat}
                    placeholder={`${dateFormatPlaceholder} ~  ${dateFormatPlaceholder}`}
                    cleanable={true}
                    placement={reportIndex == "5" ? "leftStart" : "rightStart"}
                    onKeyPress={(event) => {
                      if (!/[0-9]/.test(event.key)) {
                        event.preventDefault();
                      }
                    }}
                    style={{
                      display: "inline-block",
                      padding: "0",
                      border: "0",
                      width: "100%",
                      color: "black",
                    }}
                    size="lg"
                    value={date1}
                    onChange={(update) => {
                      dateRangeChange(update);
                      setDate1(update);
                    }}
                  />
                  {startDate && endDate && (
                    <div
                      style={{
                        position: "absolute",
                        top: "45px",
                        right: "5px",
                        color: "#8080da",
                        cursor: "pointer",
                        zIndex: "99999999",
                      }}
                      onClick={() => {
                        dateRangeChange([null, null]);
                        setDate1([]);
                      }}
                    >
                      clear
                    </div>
                  )}
                </div>
                {startDate == null ? (
                  <div
                    className="date-img"
                    onMouseDown={() => {
                      setRangeCalender(!rangeCalendar);
                    }}
                  >
                    <img src={dateIcon} alt="no img" />
                  </div>
                ) : (
                  ""
                )}
              </div>
            </div>
            </Grid>
            )
            case "CheckBox":
              return (
              <Grid item xs={6}>
              <div className="detailed-by-account" style={{ display: 'flex', alignItems: 'center' }}>
                <div style={{ display: 'flex', alignItems: 'flex-start', height: '26px', paddingTop: '2px', overflow: 'hidden' }}>
                  <CheckBox
                  checked={formik?.values?.[item?.formikField][item?.key]}
                  onChange={() => formik.setFieldValue(`[${item?.formikField}][${item?.key}]`, !formik?.values?.[item?.formikField][item?.key])}
                  text={item?.label}
                  />
                </div>
                {(item?.key === "detailedByFamily" || item?.key === "detailedByPaymentMethod") && (
                  <InfoTooltip text="Breaks the report totals down into a separate line per family/account instead of one combined summary." placement="top" useFixed style={{ marginLeft: '6px' }} />
                )}
                {item?.key === "includeAccountInformation" && (
                  <InfoTooltip text="Adds extra account details (like address and contact info) as additional columns when exporting to CSV/Excel." placement="top" useFixed style={{ marginLeft: '6px' }} />
                )}
              </div>
              </Grid>
            )
            case "Account":
              return(
                <Grid item xs={6}>
              <div className="fieldContainer">
              <LabelField title={"Account"} />
              <AsyncAutoCompleteField
                name="account"
                isClearable={selectedAccount?.id ?? false}
                onInputChange={(text) => searchAction(text)}
                classNamePrefix="react-select"
                options={data}
                isLoading={loading}
                placeholder="Type 3 letters to start searching"
                handleChange={handleAccountChange}
                value={selectedAccount?.id ? {
                  id: selectedAccount.accountId,
                  label: selectedAccount.name,
                  value: selectedAccount.id,
                } : null}
              />
            </div>
            </Grid>
            )
            case "Account IDs":
              return (
                <Grid item xs={6}>
                  <div className="fieldContainer">
                    <LabelField title={"Account"} />
                    <Select
                      isMulti
                      isClearable
                      onInputChange={(text) => searchAction(text)}
                      classNamePrefix="react-select"
                      formatOptionLabel={formatOptionLabel}
                      options={data}
                      isLoading={loading}
                      styles={colourStyles}
                      onChange={(values) => {
                        formik.setFieldValue("account.accounts", values || []);
                      }}
                      value={formik.values.account?.accounts || []}
                      components={{ DropdownIndicator }}
                      placeholder={<span style={{ color: "#b5b5c3" }}>Select</span>}
                    />
                  </div>
                </Grid>
              )
            case "Batch ID":
              return(  
                <Grid item xs={6}>
              <div className="fieldContainer amountField">
              <InputField
                {...{
                  name: "batch_id",
                  title: "Batch ID",
                  placeholder: "Batch ID",
                  value: filters?.batchId,
                }}
                type="text"
                min="0"
                handleChange={(e) => {
                  let amount = e.target.value;
                  setFilters((prev) => ({
                    ...prev,
                    filter: {
                      ...prev.filter,
                      batchId: amount,
                    },
                  }));
                }}
              />
            </div>
            </Grid>
            )
            case "Batch Type":
              return(   
                <Grid item xs={6}>
              <div className="fieldContainer account-type">
              <div className="d-flex align-items-center">
                <LabelField title={"Batch Type"} />
                <InfoTooltip text="Synced batches have been sent to your accounting software (e.g. QuickBooks); unsynced batches haven't yet." style={{ marginLeft: '6px' }} />
              </div>
              <Select
                {...{
                  formik,
                  name: `batchStatus`,
                  checkValidation: false,
                }}
                isClearable={filters?.filter?.batchStatus ?? false}
                onInputChange={(text) => searchAction(text)}
                classNamePrefix="react-select"
                formatOptionLabel={formatOptionLabel}
                options={batchTypeOptions}
                isLoading={loading}
                styles={colourStyles}
                onChange={(value) => {
                  if(!value) {
                    const { batchStatus, ...rest } = filters.filter;
                    setFilters((prev) => ({
                      ...prev,
                      filter: {
                        ...rest,
                      },
                    }));
                    return;
                  }
                  setFilters((prev) => ({
                    ...prev,
                    filter: {
                      ...prev.filter,
                      batchStatus: value.value,
                    },
                  }));
                }}
                value={{
                  label: filters?.filter?.batchStatus ? (
                    filters?.filter?.batchStatus
                  ) : (
                    <span style={{ color: "#b5b5c3" }}> Select</span>
                  ),
                  value: filters?.filter?.batchStatus,
                }}
                components={{ DropdownIndicator }}
                isDisabled={0 > 0}
              />
            </div>
            </Grid>
            )
            case "Ledger Account":
              return ( 
                <Grid item xs={6}>
              <div className="fieldContainer AccountListReport">
              <div className="d-flex align-items-center">
                <LabelField title={"Ledger Account"} />
                <InfoTooltip text="Limits the report to charges/payments posted under the selected ledger(s). Leave empty to include all ledgers." style={{ marginLeft: '6px', transform: 'translateY(-4px)' }} />
              </div>
              <MenuMultiCheckBox
                Items={ledgers}
                formik={formik}
                isLedger={true}
                withBorder={true}
                field="all_ledger_sub_data"
              />
            </div>
            </Grid>
            )
            case "Account Type":
              case "Billing type":
                case "Category Type":
                  case "Member Type":
                  case "Payment method":
                    return(
                      <Grid item xs={6}>
                      <MultiSelect placeholder='Select' 
                            label={item?.type} isOptinal={!item?.isOptinal} 
                            isCheckBoxOption={true} options={item?.data} loading={item?.loading}
                            formikField={item?.formikField}
                            variableForSave={item?.variableForSave}
                            formik={formik}
                            handleFormikChange={handleFormikChange}
                            isAccount={true}
                            formikKey={item?.formikKey}
                            searchAction={searchAction}
                            isMultiple={true}
                            styleLabel={{ fontWeight: '500',color:'black'}}
                            total={item?.total}
                        />
                        </Grid >
                    )

            case "empty":
              return (
              <Grid item xs={6}>

              </Grid>
            )
              default:
                break;
            }
          }})
        )})}
        </Grid>
      </div>
    </div>
  );
};
